import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Print from 'vue-print-nb'
Vue.use(Print);
import 'amfe-flexible';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/index.scss'

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
